/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalQuestionDataAttributeSchema = z.enum(['name', 'email', 'phone', 'contact_consent', 'cv'])

export type AdditionalQuestionDataAttributeSchema = z.infer<typeof additionalQuestionDataAttributeSchema>
